import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import authService from "../services/AuthService";

const Header = () => {
  const [userName, setUserName] = useState("");
  const { userDetails, isAdminUser } = useAuth();
  useEffect(() => {
    const parseUserDetails = authService.ensureParsed(userDetails);
    setUserName(parseUserDetails?.school_name);
  }, [userDetails]);
  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link className="nav-link" data-widget="pushmenu" role="button">
              <i className="fas fa-bars" />
            </Link>
          </li>
          {!isAdminUser && (
            <li
              className="nav-item d-none d-sm-inline-block"
              style={{ paddingTop: "3px" }}
            >
              <h4>{userName}</h4>
            </li>
          )}
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link className="nav-link" data-widget="fullscreen" role="button">
              <i className="fas fa-expand-arrows-alt" />
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Header;
